export default {"src":"/_next/static/media/cxVal3.1fdba8e3.svg","height":155,"width":67,"blurWidth":0,"blurHeight":0};